"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var uuid = _interopRequireWildcard(require("uuid"));

var _react = require("react");

var _jwtDecode = _interopRequireDefault(require("jwt-decode"));

var useClientSourceId = function useClientSourceId(_ref) {
  var clientKey = _ref.clientKey,
      userId = _ref.userId,
      authorization = _ref.authorization,
      id = _ref.id,
      localStorage = _ref.localStorage;
  var clientSourceKey = (0, _react.useMemo)(function () {
    var _decoded$scope, _decoded$scope$split, _decoded$scope$split$;

    if (!authorization) {
      return "".concat(clientKey, "/").concat(userId);
    }

    var decoded = (0, _jwtDecode["default"])(authorization);
    var scopeUserId = decoded === null || decoded === void 0 ? void 0 : (_decoded$scope = decoded.scope) === null || _decoded$scope === void 0 ? void 0 : (_decoded$scope$split = _decoded$scope.split(" ")) === null || _decoded$scope$split === void 0 ? void 0 : (_decoded$scope$split$ = _decoded$scope$split.find(function (s) {
      return s.includes("user_id");
    })) === null || _decoded$scope$split$ === void 0 ? void 0 : _decoded$scope$split$.replace("user_id:", "");
    return "".concat(decoded === null || decoded === void 0 ? void 0 : decoded.tenant_id, "/").concat(scopeUserId);
  }, [authorization, clientKey, userId]);
  return (0, _react.useMemo)(function () {
    if (!localStorage) {
      return;
    }

    var clientSourceIdLSKey = "clientSourceId/".concat(clientSourceKey);
    var localStorageClientSourceId = localStorage.getItem(clientSourceIdLSKey);

    if (localStorageClientSourceId) {
      return id ? "".concat(localStorageClientSourceId, "/").concat(id) : localStorageClientSourceId;
    }

    var newClientSourceId = uuid.v4();
    localStorage.setItem(clientSourceIdLSKey, newClientSourceId);
    return id ? "".concat(newClientSourceId, "/").concat(id) : newClientSourceId;
  }, [localStorage, clientSourceKey, id]);
};

var _default = useClientSourceId;
exports["default"] = _default;